import { FREEBUFF_WEB_URL_PROD } from '@anvil/common/constants/hosts'
import { env, IS_DEV } from '@anvil/common/env'

import { IS_FREEBUFF } from '../utils/constants'

// Get the website URL from environment or use default
export const WEBSITE_URL = env.NEXT_PUBLIC_ANVIL_APP_URL

// Freebuff login flow uses the freebuff web app instead of codebuff.com
const FREEBUFF_WEB_URL = IS_DEV
  ? 'http://localhost:3002'
  : (env.NEXT_PUBLIC_FREEBUFF_APP_URL ?? FREEBUFF_WEB_URL_PROD)
export const LOGIN_WEBSITE_URL = IS_FREEBUFF ? FREEBUFF_WEB_URL : WEBSITE_URL

// Anvil ASCII Logo - ANSI Shadow figlet wordmark, compact version for
// 80-width terminals. Spells ANVIL in the same block-lettering style as the
// Codebuff brand mark: box-corners, shadow faces, two-tone (block + accent).
export const LOGO = `
 █████╗ ███╗   ██╗██╗   ██╗██╗██╗
██╔══██╗████╗  ██║██║   ██║██║██║
███████║██╔██╗ ██║██║   ██║██║██║
██╔══██║██║╚██╗██║║██╗ ██╔╝██║██║
██║  ██║██║ ╚████║╚█████╔╝ ██║███████╗
╚═╝  ╚═╝╚═╝  ╚═══╝ ╚════╝  ╚═╝╚══════╝
`

export const LOGO_SMALL = `
 █████╗ ███╗   ██╗██╗   ██╗██╗██╗
██╔══██╗████╗  ██║██║   ██║██║██║
███████║██╔██╗ ██║██║   ██║██║██║
██╔══██║██║╚██╗██║║██╗ ██╔╝██║██║
██║  ██║██║ ╚████║╚█████╔╝ ██║███████╗
╚═╝  ╚═╝╚═╝  ╚═══╝ ╚════╝  ╚═╝╚══════╝
`

// Shadow/border characters that receive the sheen animation effect
export const SHADOW_CHARS = new Set([
  '╚',
  '═',
  '╝',
  '║',
  '╔',
  '╗',
  '╠',
  '╣',
  '╦',
  '╩',
  '╬',
])

// Modal sizing constants
export const DEFAULT_TERMINAL_HEIGHT = 24
export const MODAL_VERTICAL_MARGIN = 2 // Space for top positioning (1) + bottom margin (1)
export const MAX_MODAL_BASE_HEIGHT = 22 // Maximum height when no warning banner
export const WARNING_BANNER_HEIGHT = 3 // Height of invalid credentials banner (padding + text + padding)

// Sheen animation constants
export const SHEEN_WIDTH = 5
export const SHEEN_STEP = 2 // Advance 2 positions per frame for efficiency
export const SHEEN_INTERVAL_MS = 150
